import { Container, Divider } from "@material-ui/core";
import { Box } from "@mui/material";
import axios from "axios";
import {
  ArrayChip,
  CustomTable,
  ModalError,
  Page,
  SearchTextInput,
  StatusChip,
} from "components";
import { HeaderTitle } from "layouts";
import { getTotalPage } from "lib";
import { debounce } from "lodash";
import { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router";
import { hardBaseUrl } from "services/urlConstant";
import { globalStyles } from "styles";
import { formatDate, getCookie, getErrors } from "utils";

const ContractList = () => {
  const classes = globalStyles();
  const history = useHistory();
  const userLogin = getCookie("auth", `${process.env.REACT_APP_NAME}_user`);
  const token = localStorage.getItem("token");
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  const urlParams = new URLSearchParams(location.search);
  const paramsSearch = urlParams.get("search");
  const paramsPage = urlParams.get("page");
  const paramsSize = urlParams.get("size");

  const [loadingPage, setLoadingPage] = useState(false);
  const [dataTable, setDataTable] = useState([]);
  const [queryParams, setQueryParams] = useState({
    page: Number(paramsPage) || 1,
    size: Number(paramsSize) || 10,
    search: paramsSearch || "",
    publisher_id: userLogin?.publisher?.publisher_id,
  });
  const [tableTotalPage, setTableTotalPage] = useState(1);

  const handleChangePageParams = (value, key) => {
    urlParams.set(key, value);
    history.replace({
      pathname: location.pathname,
      search: urlParams.toString(),
    });
  };
  const handleChangeQueryParams = (value, key) => {
    setQueryParams(currentState => ({
      ...currentState,
      ...(key !== "page" && { page: 1 }),
      [key]: value,
    }));
    handleChangePageParams(value, key);
    if (key !== "page") {
      handleChangePageParams(1, "page");
    }
  };

  const getDataTable = async () => {
    try {
      setLoadingPage(true);
      const res = await axios.get(`${hardBaseUrl}/composer/contract`, {
        headers,
        params: queryParams,
      });
      const { data, meta } = res?.data;
      setDataTable(data || []);
      const pageCount = getTotalPage(meta?.total, queryParams?.size);
      setTableTotalPage(pageCount || 1);
    } catch (error) {
      ModalError(getErrors(error?.response));
    } finally {
      setLoadingPage(false);
    }
  };
  const debounceDataTable = useCallback(
    debounce(() => {
      getDataTable();
    }, 500),
    [queryParams]
  );

  useEffect(() => {
    const isSearching = Boolean(queryParams?.search);
    if (isSearching) {
      debounceDataTable();
      return () => {
        debounceDataTable.cancel();
      };
    } else {
      getDataTable();
    }
  }, [queryParams, debounceDataTable]);

  return (
    <Page className={classes.root} title="Contract">
      <Container maxWidth={false}>
        <HeaderTitle title="Contract" breadcrumbData={breadcrumbData} />
        <Divider className={classes?.divider} />
        <Box mb="16px">
          <SearchTextInput
            placeholder="Search"
            value={queryParams?.search}
            onChange={e => handleChangeQueryParams(e?.target?.value, "search")}
          />
        </Box>
        <CustomTable
          isLoading={loadingPage}
          columnTable={columnTable}
          data={dataTable}
          page={queryParams?.page}
          pageSize={queryParams?.size}
          pageCount={tableTotalPage}
          handleChangePage={(_, page) => handleChangeQueryParams(page, "page")}
          handleChangePageSize={e =>
            handleChangeQueryParams(e?.target?.value, "size")
          }
          isHaveAction
          handleView={item =>
            history.push(
              `/pencipta/kontrak/detail-kontrak/${item.contract_id}/${item.song_id}`
            )
          }
        />
      </Container>
    </Page>
  );
};

const breadcrumbData = [
  {
    label: "Home",
    link: "/pencipta/dashboard-pencipta",
  },
  {
    label: "Contract",
    active: true,
  },
];
const columnTable = [
  {
    name: "contract_number",
    title: "Contract number	",
  },
  {
    name: "song_title",
    title: "Song Title",
    renderText: item => <ArrayChip list={item} />,
  },
  {
    name: "publisher_name",
    title: "Publisher",
  },
  {
    name: "start_date",
    title: "Start Date",
    renderText: item => formatDate(item),
  },
  {
    name: "end_date",
    title: "End Date",
    renderText: item => {
      return item !== "-" ? formatDate(item) : "-";
    },
  },
  {
    name: "status",
    title: "Status",
    renderText: item => (
      <StatusChip
        label={item === "Aktif" ? "Active" : "Inactive"}
        type={item === "Aktif" && "success"}
      />
    ),
  },
];

export default ContractList;
